import { LocalAudioTrack } from 'twilio-video';
import React from 'react';

import Button from '@material-ui/core/Button';
import MicIcon from '../../../icons/MicIcon';
import MicOffIcon from '../../../icons/MicOffIcon';

import useLocalAudioToggle from '../../../hooks/useLocalAudioToggle/useLocalAudioToggle';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

export default function ToggleAudioButton(props: {
	disabled?: boolean;
	className?: string;
}) {
	const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
	const { localTracks } = useVideoContext();
	const hasAudioTrack = localTracks.some(
		(track) =>
			track.kind === 'audio' &&
			!track.isStopped &&
			(
				(track as LocalAudioTrack).noiseCancellation?.sourceTrack ||
				track.mediaStreamTrack
			)?.readyState !== 'ended',
	);

	return (
		<Button
			className={props.className}
			onClick={toggleAudioEnabled}
			disabled={props.disabled}
			startIcon={isAudioEnabled ? <MicIcon /> : <MicOffIcon />}
			data-cy-audio-toggle
		>
			{!hasAudioTrack
				? 'Try microphone again'
				: isAudioEnabled
					? 'Mute'
					: 'Unmute'}
		</Button>
	);
}
